/**
 * @generated SignedSource<<e5d84e4e9c7d71d0c29ff8fcb26230bb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventMap_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "latitude",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "longitude",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EventMarker",
      "kind": "LinkedField",
      "name": "marker",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "InformativeMarker_marker"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "VisualizationMap",
      "kind": "LinkedField",
      "name": "map",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MapBase_map"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "EventVisualization",
  "abstractKey": null
};

node.hash = "91fcbf8f76cb1c67815040c85e338c3c";

module.exports = node;
